import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function rebatesRCTIReducer(state = initialState.locations, action) {
  switch (action.type) {
    case types.LIST_REBATES_RCTI_SUCCESS:
      return {
        ...state, items: action.items, total: action.total
      };
    case types.CLEAR_REBATES_RCTI_SUCCESS: 
        return {
            ...state, items: [], total: 0
          };
    case types.GET_REBATES_RCTI_DETAIL_SUCCESS: 
        return {
            ...state, detail: action.data
        };
    case types.UPDATE_REBATES_RCTI_LIST_FILTERS_SUCCESS:
        return {
            ...state, listFilters: {...action.data}
        };
    case types.LIST_RCTI_INVOICES_SUCCESS:
        return {
          ...state, invoices: {
            items: action.items,
            total: action.total
          }
        };
    case types.CLEAR_RCTI_INVOICES_SUCCESS:
        return {
          ...state, invoices: {
            items: [],
            total: 0
          }
        };
    default:
      return state;
  }
}
